// extracted by mini-css-extract-plugin
module.exports = {"btn":"ManualDevicePaymentForm_btn__cAcEo"};